module.exports = __webpack_public_path__ + "img/ios-2.ddfeff0c.png";